<div class="pw-textarea" [formGroup]="parentFormGroup">
    <label class="pw-textarea__label">{{data.label}}</label>
    <div class="pw-textarea__wrapper">
        <textarea class="pw-textarea__textarea" name="{{data.name}}" formControlName="{{data.name}}" id="{{data.id}}" cols="{{data.cols || 30}}" rows="{{data.rows || 5}}"></textarea>
    </div>
    <label class="pw-textarea__error" [innerHTML]="formStatus.formErrors[data.name]" id="error_{{ data.name }}" *ngIf="formStatus.formErrors[data.name]" role="alert"></label>
</div>